'use client'
import { useTranslator } from '@/hooks'
import { mq, presets, vw } from '@/styles'
import { memo } from 'react'
import styled from 'styled-components'

interface ISectionIngredients {
  data: string | JSON
}

export const SectionIngredients = memo<ISectionIngredients>(({ data }) => {
  const { t } = useTranslator()

  return (
    <section>
      <H2>{t('project.product.product_description.nutritional_value.ingredients')}</H2>
      <P>{data as string}</P>
    </section>
  )
})


const H2 = styled.h2`
  ${presets.font53}
  color: var(--color-text--darker);
  margin: ${vw(60, 'mobile')} 0 ${vw(20, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    margin: ${vw(80, 'tablet')} 0 ${vw(20, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    margin: ${vw(80, 'desktop')} 0 ${vw(20, 'desktop')};
  }

  ${mq.greaterThan('desktop')} {
    margin: 80px 0 20px;
  }
`

const P = styled.p`
  ${presets.font18}
  color: var(--color-text);
  line-height: 125% !important;
`
